import React from 'react';
import { Tooltip } from 'antd';
import { truncateText, needsTruncation } from '../utils/textUtils';

interface TruncatedCellProps {
  text: string;
  maxLength?: number;
}

export const TruncatedCell: React.FC<TruncatedCellProps> = ({ text, maxLength = 50 }) => {
  if (!text) {
    return <span>-</span>;
  }

  if (!needsTruncation(text, maxLength)) {
    return <span>{text}</span>;
  }

  const truncatedText = truncateText(text, maxLength);

  return (
    <Tooltip
      title={text}
      placement="topLeft"
      styles={{
        root: {
          maxWidth: '300px',
          wordBreak: 'break-word',
          whiteSpace: 'pre-wrap',
        },
      }}
    >
      <span style={{ cursor: 'help' }}>{truncatedText}</span>
    </Tooltip>
  );
};
